import React from 'react';
import './FindResources.css'; 

const FindResources = () => {
  return (
    <div className="widget">
      <div className="content">
        <h2>Welcome to LitDiversity.</h2>
        <p>Find resources and guides to support you as you share diverse books with your students!</p>
        <button className="explore-button">Explore More</button>
      </div>
    </div>
  );
};

export default FindResources;
